import * as React from 'react';
import { Link, FunctionField, useTranslate } from 'react-admin';
import { Stack, Typography } from '@mui/material';
import ChangeUserStatus from './ChangeUserStatus';
import MailIcon from '@mui/icons-material/Mail';
import ValidityStatusBadge from './ValidityStatusBadge';
import { StatsTooltip } from '../../components/statistics/common';

const SchoolNameField = props => {
    const translate = useTranslate();
    
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('fi-FI', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
        });
    };
    
    const hasPendingInvitations = school => {
        return school.public?.invitations?.some(
            invitation => invitation.status === 0
        );
    };
    const invitationsCount = school => {
        return (
            school.public?.invitations?.filter(
                invitation => invitation.status === 0
            )?.[0]?.counter || 1
        );
    };
    return (
        <FunctionField
            {...props}
            render={record => {
                return (
                    <Stack direction="row" spacing={1}>
                        <Stack direction="column" spacing={0}>
                            {record?.schools?.map(school => {
                                return (
                                    <Stack
                                        key={school.guid} // added key here (root of map)
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        {school.status !== 3 && (
                                            <ChangeUserStatus
                                                key={`status-${school.guid}`}
                                                button={false}
                                                action={
                                                    school.status !== 2 &&
                                                    school.status > 0
                                                        ? 'unremove'
                                                        : 'remove'
                                                }
                                                school_guid={school.guid}
                                            />
                                        )}
                                        {school.status === 3 && (
                                            <ChangeUserStatus
                                                key={`invitation-${school.guid}`}
                                                button={false}
                                                action="invitation"
                                                school_guid={school.guid}
                                                title={
                                                    hasPendingInvitations(school)
                                                        ? `${translate(
                                                              'resources.user.invitation.pending'
                                                          )}, lähetetty ${invitationsCount(
                                                              school
                                                          )} kpl`
                                                        : translate(
                                                              'resources.user.invitation.none'
                                                          )
                                                }
                                                icon={
                                                    <MailIcon
                                                        style={{
                                                            color: hasPendingInvitations(
                                                                school
                                                            )
                                                                ? '#4caf50'
                                                                : '#aaaaaa',
                                                            fontSize: '1rem',
                                                        }}
                                                    />
                                                }
                                            />
                                        )}
                                        <Stack
                                            direction="row"
                                            spacing={0}
                                            alignItems="center"
                                        >
                                            <StatsTooltip 
                                                title={[
                                                    school?.author?.created ? `Liitytty${school?.author?.mpass ? ' (MPASS)' : ''}: ${formatDate(school.author.created)}` : null,
                                                    school?.author?.modified ? `Muokattu: ${formatDate(school.author.modified)}` : null,
                                                ].filter(Boolean).join('\n')}
                                                followCursor
                                                placement="top-start"
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            padding: '12px 16px',
                                                            fontSize: '14px',
                                                            lineHeight: 1.4,
                                                            whiteSpace: 'pre-line',
                                                        }
                                                    }
                                                }}
                                            >
                                                <span style={{display: 'flex', alignItems: 'center'}}>
                                                    <Link
                                                        sx={{
                                                            textDecoration: school.school_status === 1 ? 'line-through' : 'none',
                                                            color:
                                                                school.status === 0
                                                                    ? '#000'
                                                                    : 'red',
                                                            '&:hover': {
                                                                textDecoration:
                                                                    'underline',
                                                            },
                                                        }}
                                                        to={'/school/' + school.guid}
                                                        onClick={e =>
                                                            e.stopPropagation()
                                                        }
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            component="span"
                                                        >
                                                            {school.name}
                                                        </Typography>
                                                    </Link>
                                                    {school?.services?.includes('opepalvelu') && <span style={{backgroundColor: '#afbec5',fontSize:10,color: 'rgb(255, 255, 255)',padding: '1px 6px',borderRadius: 3,background: 'rgba(96, 125, 139, 0.5)',height: 15,marginLeft:3}}>OOP</span>} 
                                                    {school?.services?.includes('finnlectura') && <span style={{backgroundColor: '#afbec5',fontSize:10,color: 'rgb(255, 255, 255)',padding: '1px 6px',borderRadius: 3,background: 'rgba(96, 125, 139, 0.5)',height: 15,marginLeft:3}}>FL</span>}
                                                    {school?.services?.includes('crm') && <span style={{backgroundColor: '#afbec5',fontSize:10,color: 'rgb(255, 255, 255)',padding: '1px 6px',borderRadius: 3,background: 'rgba(96, 125, 139, 0.5)',height: 15,marginLeft:3}}>CRM</span>}
                                                </span>
                                                
                                            </StatsTooltip>
                                            {(school.status === 1 || school?.public?.validfrom) && (
                                                <ValidityStatusBadge
                                                    record={school}
                                                    statusSource="status"
                                                    validFromSource="public.validfrom"
                                                    validToSource="public.validto"
                                                    statusResourceKey="resources.user.status"
                                                    variant="caption"
                                                />
                                            )}
                                            {school?.public?.isadmin && (
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        backgroundColor:
                                                            '#4caf50',
                                                        color: 'white',
                                                        padding: '0 4px',
                                                        borderRadius: '4px',
                                                        marginLeft: '8px',
                                                    }}
                                                >
                                                    {translate(
                                                        `resources.user.fields.group.isadmin`
                                                    )}
                                                </Typography>
                                            )}
                                        </Stack>
                                    </Stack>
                                );
                            })}
                        </Stack>
                        <Stack direction="row" spacing={0} alignItems="center">
                            {props.approval === 'true' &&
                                (record.status === 2 ||
                                    record.schools.filter(s => s.status === 2)
                                        .length > 0) && (
                                    <ChangeUserStatus
                                        key="change-teacher-status"
                                        record={record}
                                        button={false}
                                        title={translate(
                                            'resources.teacher.actions.approve.button_title'
                                        )}
                                    />
                                )}
                        </Stack>
                    </Stack>
                );
            }}
        />
    );
};

export default SchoolNameField;